import { ArrowLeft, Clock, Plus, X } from 'lucide-react';
import { Button } from '@/ui/design-system/components/ui/button';
import { SpateAiIcon } from '@/ui/design-system/components/ui/spate-ai-icon';
import { mixpanelTrack } from 'utils/app/configureMixpanel';
import { useAssistantContext } from './AssistantProvider';

interface ChatSessionHeaderProps {
    onClose: () => void;
    showHistory: boolean;
    onToggleHistory: () => void;
    onBackFromHistory: () => void;
}

const ChatSessionHeader = ({
    onClose,
    showHistory,
    onToggleHistory,
    onBackFromHistory,
}: ChatSessionHeaderProps) => {
    const { createNewChat } = useAssistantContext();

    if (showHistory) {
        return (
            <div className="flex items-center justify-between p-4 border-b border-border shrink-0">
                <div className="flex items-center gap-3">
                    <Button
                        variant="secondary"
                        size="icon"
                        className="h-9 w-9"
                        onClick={onBackFromHistory}
                        aria-label="Back to chat"
                    >
                        <ArrowLeft size={16} />
                    </Button>
                    <span className="text-base font-medium text-card-foreground">
                        Chat history
                    </span>
                </div>
            </div>
        );
    }

    return (
        <div className="flex items-center justify-between p-4 border-b border-border shrink-0">
            {/* Left: branding */}
            <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-9 h-9 rounded-lg bg-muted text-primary">
                    <SpateAiIcon size={16} />
                </div>
                <div>
                    <div className="text-base font-semibold text-card-foreground leading-tight">
                        Spate AI
                    </div>
                    <div className="text-xs text-muted-foreground">
                        AI trend assistant
                    </div>
                </div>
            </div>

            {/* Right: actions */}
            <div className="flex items-center gap-4 shrink-0">
                <Button
                    variant="secondary"
                    size="icon"
                    className="h-9 w-9"
                    onClick={() => {
                        if (!showHistory)
                            mixpanelTrack('AI Assistant History Viewed');
                        onToggleHistory();
                    }}
                    aria-label="Chat history"
                >
                    <Clock size={16} />
                </Button>

                <Button
                    variant="secondary"
                    size="icon"
                    className="h-9 w-9"
                    onClick={createNewChat}
                    aria-label="New chat"
                >
                    <Plus size={16} />
                </Button>

                <div className="h-5 border-r border-border mx-1" />

                <Button
                    variant="secondary"
                    size="icon"
                    className="h-9 w-9"
                    onClick={onClose}
                    aria-label="Close assistant"
                >
                    <X size={16} />
                </Button>
            </div>
        </div>
    );
};

export default ChatSessionHeader;
